import { useRef, useState, useEffect } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import ClipboardJS from 'clipboard'
import { Box, PolymorphicComponentProps } from 'react-polymorphic-box';

const defaultElement = 'div';

type CopyableProps<E extends React.ElementType> = PolymorphicComponentProps<
  E,
  {
    copyContent: string;
    tooltipMsg?: string;
    onCopy?: () => void;
  }
>;

const Copyable: <E extends React.ElementType = typeof defaultElement>(
  props: CopyableProps<E>
) => JSX.Element = (props) => {
  const [show, setShow] = useState(false)
  const { copyContent, tooltipMsg, onCopy } = props
  const [tooltip, setTooltip] = useState(tooltipMsg)
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (ref.current) {
      let clipboard = new ClipboardJS(ref.current)
      clipboard.on('success', () => {
        setTooltip('Copied')
        onCopy && onCopy()
      })
    }
  }, [tooltip])

  return (
    <OverlayTrigger
      show={show}
      placement="top"
      overlay={<Tooltip id="copyable">{tooltip}</Tooltip>}
      trigger="click"
      onToggle={(show) => {
        setShow(show)
        if (show) {
          setTimeout(() => {
            setShow(false)
          }, 1500)
        }
      }}
    >
      <Box as={defaultElement} ref={ref} {...props} data-clipboard-text={copyContent}>
        {props.children}
      </Box>
    </OverlayTrigger>
  )
}

export default Copyable
